import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ShellComponent } from '@app/shell/shell.component';

const routes: Routes = [
  {
    path: '',
    component: ShellComponent,
    data: {
      isHomePage: true,
    },
    children: [
      {
        path: '',
        loadComponent: () => import('@app/home/home.component').then((c) => c.HomeComponent),
        data: {
          isHomePage: true,
        },
      },
      {
        path: 'list/:city/:dealType',
        loadComponent: () => import('@app/shell/real-property-object-list/real-property-object-list.component').then((c) => c.RealPropertyObjectListComponent),
        data: {
          isHomePage: false,
        },
      },

      {
        path: 'map/:city/:dealType',
        loadComponent: () => import('@app/shell/yandex-map/yandex-map.component').then((c) => c.YandexMapComponent),
        data: {
          isHomePage: false,
        },
      },
      {
        path: 'real-property/:id',
        loadComponent: () => import('@app/shell/real-property-detail/real-property-detail.component').then((c) => c.RealPropertyDetailComponent),
      },
      {
        path: 'agent/:id',
        loadComponent: () => import('@app/shell/real-property-agent/real-property-agent.component').then((c) => c.RealPropertyAgentComponent),
      },
      {
        path: 'favorites',
        loadComponent: () => import('@app/shell/favorites/favorites.component').then((c) => c.FavoritesComponent),
      },
      {
        path: 'our-specialists',
        loadComponent: () => import('@app/shell/out-specialists/out-specialists.component').then((c) => c.OutSpecialistsComponent),
      },
      {
        path: 'save-search',
        loadComponent: () => import('@app/shell/saved-search/saved-search.component').then((c) => c.SavedSearchComponent),
      },
      {
        path: 'contract/review-act/signing/:id',
        loadComponent: () => import('@app/shell/signature/act-show/act-show.component').then((c) => c.ActShowComponent),
      },
      {
        path: 'contract/sell-review-act/signing/:id',
        loadComponent: () => import('@app/shell/signature/act-view/act-view.component').then((c) => c.ActViewComponent),
      },
      {
        path: 'history',
        loadComponent: () => import('@app/shell/history/history.component').then((c) => c.HistoryComponent),
      },
      {
        path: 'live',
        loadComponent: () => import('@app/shell/live-vitrina/live-vitrina.component').then((c) => c.LiveVitrinaComponent),
      },
      {
        path: 'test',
        loadComponent: () => import('@app/shared/header-slider/header-slider.component').then((c) => c.HeaderSliderComponent),
      },
      {
        path: 'academy',
        loadComponent: () => import('@app/shell/academy/academy.component').then((c) => c.AcademyComponent),
      },
      {
        path: 'top-designer-flats',
        loadComponent: () => import('@app/shell/top-100-designer/top-100-designer.component').then((c) => c.Top100DesignerComponent),
      },
      {
        path: 'top-agents',
        loadComponent: () => import('@app/shell/top-agents/top-agents.component').then((c) => c.TopAgentsComponent),
      },
      {
        path: 'top-team',
        loadComponent: () => import('@app/shell/top-team/top-team.component').then((c) => c.TopTeamComponent),
      },
      {
        path: 'team-detail/:id',
        loadComponent: () => import('@app/shell/team-detail/team-detail.component').then((c) => c.TeamDetailComponent),
      },
      {
        path: 'news-portal',
        loadComponent: () => import('@app/shell/news-portal/news-portal.component').then((c) => c.NewsPortalComponent),
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ShellRoutingModule {}
